import React from 'react';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { IconButtonProps } from 'components/Icons/constants';
import PencilSvg from './pencil.svg';
import cn from './styles.module.scss';

export const PencilIcon = (props: any) => <Icon component={PencilSvg} {...props} />;

export const PencilIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  ({ size = 'medium', iconSize = 16, ...props }, ref) => (
    <Button
      ref={ref}
      type={ButtonType.OutlineIcon}
      icon={<PencilSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
PencilIconButton.displayName = 'PencilIconButton';

export const PencilIconRounded = ({ className, ...props }: any) => (
  <div className={classNames(cn.roundedIcon, className)}>
    <PencilIcon {...props} />
  </div>
);
